import { Stack, Typography } from "@mui/material";
import React from "react";
import { ReactComponent as Thanks } from "../assets/Thanks.svg";

function Thankyou() {
  return (
    <Stack
      spacing={2}
      alignItems="center"
      height={"90vh"}
      justifyContent="center"
      mx={2}
    >
      <Typography
        fontWeight={"700"}
        fontSize={{ xs: "30px", sm: "40px", md: "50px", lg: "64px" }}
      >
        {" "}
        THANK YOU!
      </Typography>
      <Thanks />
      <Typography color="rgba(106, 106, 106, 1)" textAlign={"center"}>
        We will update you soon with your invite.
      </Typography>
      <Typography color="rgba(106, 106, 106, 1)">Stay tuned!</Typography>
    </Stack>
  );
}

export default Thankyou;
